mutation ActivateSmsDripSequence($input: SmsDripSequenceActivateInput!) {
    smsDripSequenceActivate(input: $input) {
        dripSequence {
            id
            status
            editions {
                edges {
                    node {
                        id
                        status
                    }
                }
            }
        }
    }
}
